(function () {
  'use strict';

  const SELECTORS = {
    hamburger: '[data-laku-menu-toggle]',
    overlay: '[data-laku-menu-overlay]',
    menu: '[data-laku-mobile-menu]',
    closeBtn: '[data-laku-menu-close]',
    focusable:
      'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])',
  };

  const BODY_CLASS = 'mobile-menu-open';

  const state = { open: false, scrollY: 0, lastFocus: null };

  function getEls() {
    return {
      hamburger: document.querySelector(SELECTORS.hamburger),
      overlay: document.querySelector(SELECTORS.overlay),
      menu: document.querySelector(SELECTORS.menu),
      closeBtn: document.querySelector(SELECTORS.closeBtn),
    };
  }

  function lockScroll() {
    state.scrollY = window.scrollY || window.pageYOffset || 0;
    document.body.style.top = -state.scrollY + 'px';
    document.body.classList.add(BODY_CLASS);
  }

  function unlockScroll() {
    document.body.classList.remove(BODY_CLASS);
    document.body.style.top = '';
    window.scrollTo(0, state.scrollY);
  }

  function trapFocus(menu, e) {
    const nodes = menu.querySelectorAll(SELECTORS.focusable);
    if (!nodes.length) return;
    const first = nodes[0];
    const last = nodes[nodes.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      last.focus();
      e.preventDefault();
    } else if (!e.shiftKey && document.activeElement === last) {
      first.focus();
      e.preventDefault();
    }
  }

  function open() {
    const els = getEls();
    if (!els.hamburger || !els.menu) return;
    state.lastFocus = document.activeElement;
    state.open = true;
    els.hamburger.setAttribute('aria-expanded', 'true');
    els.menu.setAttribute('aria-hidden', 'false');
    if (els.overlay) els.overlay.setAttribute('aria-hidden', 'false');
    lockScroll();
    const firstLink = els.menu.querySelector(SELECTORS.focusable);
    if (firstLink) firstLink.focus();
  }

  function close() {
    const els = getEls();
    if (!els.hamburger) return;
    state.open = false;
    els.hamburger.setAttribute('aria-expanded', 'false');
    if (els.menu) els.menu.setAttribute('aria-hidden', 'true');
    if (els.overlay) els.overlay.setAttribute('aria-hidden', 'true');
    unlockScroll();
    if (state.lastFocus && typeof state.lastFocus.focus === 'function') {
      state.lastFocus.focus();
    }
  }

  function toggle() {
    state.open ? close() : open();
  }

  function onKeydown(e) {
    if (!state.open) return;
    if (e.key === 'Escape') {
      e.preventDefault();
      close();
      return;
    }
    if (e.key === 'Tab') {
      const els = getEls();
      if (els.menu) trapFocus(els.menu, e);
    }
  }

  function init() {
    const els = getEls();
    if (!els.hamburger) return;

    els.hamburger.setAttribute('aria-expanded', 'false');
    if (els.menu) els.menu.setAttribute('aria-hidden', 'true');
    if (els.overlay) els.overlay.setAttribute('aria-hidden', 'true');

    els.hamburger.addEventListener('click', function (e) {
      e.preventDefault();
      toggle();
    });

    if (els.overlay) {
      els.overlay.addEventListener('click', close);
    }

    if (els.closeBtn) {
      els.closeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        close();
      });
    }

    if (els.menu) {
      els.menu.addEventListener('click', function (e) {
        const link = e.target.closest('a[href]');
        if (link) close();
      });
    }

    document.addEventListener('keydown', onKeydown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
